import dayjs from "dayjs";
import type { ComputeType } from "./types";

const CLUSTER_SOURCE_LABELS: Record<string, string> = {
  UI: "All Purpose",
  JOB: "Job Cluster",
  API: "API",
  MODELS: "Model Serving",
  PIPELINE: "Pipeline",
  PIPELINE_MAINTENANCE: "Pipeline Maintenance",
  SQL: "SQL Warehouse",
};

export const getClusterSourceLabel = (source: string | null | undefined): string =>
  CLUSTER_SOURCE_LABELS[source || "UI"] || source || "Unknown";

export const formatChartDate = (value: string, aggregation: string): string => {
  if (aggregation === "week") return value;
  if (aggregation === "month") return dayjs(value).format("MMM YYYY");
  return dayjs(value).format("MMM D");
};

// Table "Type" badge labels. Mirrors the backend list classification
// (cluster_source → compute_type): UI/API → all_purpose, JOB → jobs,
// PIPELINE → dlt (Lakeflow Declarative Pipelines / DLT). "other" stays Unknown.
const COMPUTE_TYPE_LABELS: Record<ComputeType, string> = {
  all_purpose: "All Purpose",
  jobs: "Jobs",
  dlt: "DLT",
};

export const COMPUTE_TYPE_FILTER_OPTIONS: { value: ComputeType; label: string }[] = [
  { value: "all_purpose", label: COMPUTE_TYPE_LABELS.all_purpose },
  { value: "jobs", label: COMPUTE_TYPE_LABELS.jobs },
  { value: "dlt", label: COMPUTE_TYPE_LABELS.dlt },
];

// Single-select Photon filter. Values map to the backend `enable_photon`
// boolean query param ("true"/"false"); an unset filter sends nothing.
export const PHOTON_FILTER_OPTIONS = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const getComputeTypeLabel = (computeType: string | null | undefined): string =>
  computeType && computeType in COMPUTE_TYPE_LABELS
    ? COMPUTE_TYPE_LABELS[computeType as ComputeType]
    : "Unknown";

// The Clusters Cost chart uses the same lowercase compute_type buckets as the
// table badges (all_purpose / jobs / dlt) — the backend folds Interactive into
// all_purpose and drops serverless, so the chart series match the Type column.
const COMPUTE_TYPE_CHART_COLORS: Record<ComputeType, string> = {
  all_purpose: "#4CAF50",
  jobs: "#5B8DEF",
  dlt: "#9C27B0",
};

export const getComputeTypeChartLabel = (computeType: string): string =>
  computeType in COMPUTE_TYPE_LABELS
    ? COMPUTE_TYPE_LABELS[computeType as ComputeType]
    : computeType;

export const getComputeTypeColor = (computeType: string): string =>
  computeType in COMPUTE_TYPE_CHART_COLORS
    ? COMPUTE_TYPE_CHART_COLORS[computeType as ComputeType]
    : "#9E9E9E";
